export default __webpack_public_path__ + "images/D3.682a311.png";